import { getSnippetArgs } from "../../utils"
import {
  RequestLangFieldset,
  RequestPaginationFieldset,
  RequestRefFieldset,
  RequestTypeFieldset,
} from "./components"
import { createRequest } from "./createRequest"

export const GetByTypeRequest = createRequest({
  type: "getByType",
  Fieldset() {
    return (
      <>
        <RequestTypeFieldset />
        <RequestPaginationFieldset />
        <RequestLangFieldset />
        <RequestRefFieldset />
      </>
    )
  },
  getSnippet(options) {
    return `client.getByType(${getSnippetArgs(
      options["type"] || Symbol("type"),
      {
        page: options.page,
        pageSize: options.pageSize,
        lang: options.lang,
        ref: options.ref,
      },
    )})`
  },
  run(client, options) {
    const { type, ...params } = options

    return client.getByType(String(type), params)
  },
})
